import React from 'react';

const useForceUpdate = () => React.useReducer((_) => _ + 1, 0)[1];

export default useForceUpdate;
